export const LOCALOPS_OPS_ROUTE = '/localops/ops';
export const LOCALOPS_CONCIERGE_ROUTE = '/localops/concierge';
export const LOCALOPS_OFFERING_CONCIERGE_ROUTE = '/localops/concierge/offerings';
export const LOCALOPS_OPS_LAST_TASK_ID_KEY = 'localopsOps:lastTaskId';

export function getLocalOpsOpsPlayerRecord(player) {
  return player?.data?.player || player?.player || player || null;
}

export function canViewLocalOpsOps(player) {
  const record = getLocalOpsOpsPlayerRecord(player);
  if (!record) return false;

  const role = String(record.role || '').trim();

  return role === 'admin';
}

export function hasActiveLocalOpsConciergeGrant(player, regionSlug = 'camden') {
  const record = getLocalOpsOpsPlayerRecord(player);
  if (!record) return false;

  const normalizedRegion = String(regionSlug || 'camden')
    .trim()
    .toLowerCase();
  const grants = Array.isArray(record.localOpsRoles) ? record.localOpsRoles : [];

  return grants.some((grant) => (
    grant?.role === 'conciergeAdmin' &&
    String(grant?.status || '').trim() === 'active' &&
    String(grant?.regionSlug || '').trim().toLowerCase() === normalizedRegion
  ));
}

export function canViewLocalOpsConcierge(player) {
  const record = getLocalOpsOpsPlayerRecord(player);
  if (!record) return false;

  const role = String(record.role || '').trim();
  if (role === 'admin') return true;

  return hasActiveLocalOpsConciergeGrant(player, 'camden');
}
